// Wave X-3 (2026-05-13) — 외부 바이어 통합 관리 (read-only mirror)
// 액션(approve/reject/suspend/reactivate/reset-device)은 auction.autodex.kr/admin 사이트에서 처리.

import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

function AdminAuctionBuyers({ showToast, th, td, badge, btnStyle }) {
  var [items, setItems] = useState([]);
  var [total, setTotal] = useState(0);
  var [status, setStatus] = useState('all');
  var [q, setQ] = useState('');
  var [loading, setLoading] = useState(false);
  var [detail, setDetail] = useState(null);
  var [detailLoading, setDetailLoading] = useState(false);

  function fetchList() {
    setLoading(true);
    var url = API + '/admin/auction-buyers?status=' + encodeURIComponent(status) + '&q=' + encodeURIComponent(q) + '&limit=100';
    authFetch(url)
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (d && d.success) {
          setItems((d.data && d.data.items) || []);
          setTotal((d.data && d.data.total) || 0);
        } else {
          showToast && showToast((d && d.error) || '조회 실패', 'error');
        }
      })
      .catch(function() { showToast && showToast('네트워크 오류', 'error'); })
      .finally(function() { setLoading(false); });
  }

  useEffect(function() { fetchList(); }, [status]);

  function fetchDetail(id) {
    setDetailLoading(true);
    setDetail({ id: id, loading: true });
    authFetch(API + '/admin/auction-buyers/' + id)
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (d && d.success) setDetail(d.data);
        else { setDetail(null); showToast && showToast((d && d.error) || '상세 조회 실패', 'error'); }
      })
      .catch(function() { setDetail(null); showToast && showToast('네트워크 오류', 'error'); })
      .finally(function() { setDetailLoading(false); });
  }

  function statusBadge(s) {
    if (s === 'active') return badge ? badge('active', '활성') : '활성';
    if (s === 'suspended') return badge ? badge('inactive', '정지') : '정지';
    if (s === 'rejected') return badge ? badge('inactive', '거절') : '거절';
    if (s === 'pending_approval') return badge ? badge('trial', '승인대기') : '승인대기';
    return s || '-';
  }

  function fmtKrw(n) {
    var v = parseInt(n, 10) || 0;
    return v.toLocaleString('ko-KR') + '원';
  }

  function tempColor(t) {
    var v = parseFloat(t);
    if (isNaN(v)) return '#94a3b8';
    if (v >= 38) return '#dc2626';
    if (v >= 36) return '#f59e0b';
    if (v >= 30) return '#10b981';
    return '#64748b';
  }

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16, flexWrap: 'wrap' }}>
        <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#1B3A5C' }}>👥 외부 바이어 ({total})</h3>
        <select value={status} onChange={function(e) { setStatus(e.target.value); }} style={{ padding: '6px 10px', fontSize: 13, border: '1px solid #d0d5dd', borderRadius: 6 }}>
          <option value="all">전체</option>
          <option value="active">활성</option>
          <option value="pending_approval">승인대기</option>
          <option value="suspended">정지</option>
          <option value="rejected">거절</option>
        </select>
        <input
          value={q}
          onChange={function(e) { setQ(e.target.value); }}
          onKeyDown={function(e) { if (e.key === 'Enter') fetchList(); }}
          placeholder="이름/이메일/전화 검색"
          style={{ padding: '6px 10px', fontSize: 13, border: '1px solid #d0d5dd', borderRadius: 6, minWidth: 220 }}
        />
        <button onClick={fetchList} style={Object.assign({}, btnStyle, { padding: '6px 14px' })}>검색</button>
        <a
          href="https://auction.autodex.kr/admin"
          target="_blank"
          rel="noopener noreferrer"
          style={{ marginLeft: 'auto', padding: '6px 14px', background: '#fbbf24', color: '#78350f', borderRadius: 6, fontSize: 12, fontWeight: 700, textDecoration: 'none' }}
        >
          🔧 액션 처리 → auction admin
        </a>
      </div>

      <div style={{ display: 'flex', gap: 16 }}>
        {/* 좌측 list */}
        <div style={{ flex: detail ? '0 0 56%' : '1', minWidth: 0 }}>
          {loading ? (
            <div style={{ fontSize: 13, color: '#94a3b8' }}>불러오는 중...</div>
          ) : items.length === 0 ? (
            <div style={{ fontSize: 13, color: '#94a3b8', padding: 20, textAlign: 'center', background: '#f8fafc', borderRadius: 8 }}>
              조건에 맞는 바이어가 없습니다
            </div>
          ) : (
            <div style={{ overflowX: 'auto', maxHeight: 600 }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={th}>ID</th>
                    <th style={th}>이름</th>
                    <th style={th}>연락처</th>
                    <th style={th}>매너°</th>
                    <th style={th}>구매</th>
                    <th style={th}>미수</th>
                    <th style={th}>상태</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map(function(b) {
                    var isSelected = detail && detail.basic && detail.basic.id === b.id;
                    return (
                      <tr
                        key={b.id}
                        onClick={function() { fetchDetail(b.id); }}
                        style={{ cursor: 'pointer', background: isSelected ? '#dbeafe' : 'transparent' }}
                      >
                        <td style={td}>{b.id}</td>
                        <td style={Object.assign({}, td, { fontWeight: 600 })}>
                          {b.name}
                          {b.blacklist === 1 && <span style={{ marginLeft: 6, color: '#dc2626', fontSize: 11 }}>⚠️</span>}
                        </td>
                        <td style={td}>
                          <div style={{ fontSize: 12 }}>{b.phone_e164 || b.phone || '-'}</div>
                          <div style={{ fontSize: 11, color: '#94a3b8' }}>{b.email || ''}</div>
                        </td>
                        <td style={Object.assign({}, td, { color: tempColor(b.trust_temperature), fontWeight: 700 })}>
                          {b.trust_temperature != null ? Number(b.trust_temperature).toFixed(1) + '°' : '-'}
                        </td>
                        <td style={td}>{b.total_buys || 0}</td>
                        <td style={td}>
                          {b.pending_fee_count > 0 ? (
                            <span style={{ color: '#dc2626', fontWeight: 700 }}>
                              {b.pending_fee_count}건 / {fmtKrw(b.pending_fee_total)}
                            </span>
                          ) : (
                            <span style={{ color: '#94a3b8' }}>-</span>
                          )}
                        </td>
                        <td style={td}>{statusBadge(b.status)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* 우측 detail */}
        {detail && (
          <div style={{ flex: 1, minWidth: 0, padding: 16, background: '#f8fafc', borderRadius: 8, maxHeight: 600, overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <h4 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: '#1B3A5C' }}>바이어 상세</h4>
              <button onClick={function() { setDetail(null); }} style={{ padding: '4px 10px', fontSize: 12, background: 'transparent', border: '1px solid #d0d5dd', borderRadius: 6, cursor: 'pointer' }}>✕</button>
            </div>
            {detailLoading || detail.loading ? (
              <div style={{ fontSize: 13, color: '#94a3b8' }}>불러오는 중...</div>
            ) : detail.basic ? (
              <div style={{ fontSize: 13 }}>
                <SectionTitle>📋 기본 정보</SectionTitle>
                <KV k="ID" v={detail.basic.id} />
                <KV k="이름" v={detail.basic.name} />
                <KV k="이메일" v={detail.basic.email || '-'} />
                <KV k="전화" v={detail.basic.phone_e164 || detail.basic.phone || '-'} />
                <KV k="국가" v={detail.basic.country || '-'} />
                <KV k="회사" v={detail.basic.company || '-'} />
                <KV k="가입일" v={(detail.basic.created_at || '').slice(0, 19)} />
                <KV k="상태" v={statusBadge(detail.basic.status)} />
                {detail.basic.rejection_reason && <KV k="거절사유" v={detail.basic.rejection_reason} />}
                {detail.basic.suspended_until && <KV k="정지종료" v={detail.basic.suspended_until} />}
                <KV k="device_id" v={detail.basic.device_id ? detail.basic.device_id.slice(0, 8) + '...' : '미등록'} />
                <KV k="locale" v={detail.basic.locale || 'ko'} />
                <KV k="FCM" v={detail.basic.fcm_token ? '✓' : '-'} />
                <KV k="trade_purpose" v={detail.basic.trade_purpose || '-'} />
                <KV k="추천인코드" v={detail.basic.referrer_code || '-'} />

                <SectionTitle>🌡️ 매너온도</SectionTitle>
                {detail.trust ? (
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
                    <Pill color={tempColor(detail.trust.trust_temperature)}>{Number(detail.trust.trust_temperature).toFixed(1)}°</Pill>
                    <Pill>구매 {detail.trust.total_buys || 0}건</Pill>
                    <Pill>리뷰 {detail.trust.total_reviews_received || 0}건</Pill>
                    <Pill>취소 {detail.trust.cancelled_count || 0}건</Pill>
                    <Pill>경고 {detail.trust.warning_count || 0}회</Pill>
                    {detail.trust.blacklist === 1 && <Pill color="#dc2626">⚠️ 블랙리스트</Pill>}
                  </div>
                ) : (
                  <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 12 }}>아직 매너온도 row 없음</div>
                )}

                <SectionTitle>💰 거래수수료 이력 ({detail.fees ? detail.fees.length : 0}건)</SectionTitle>
                {detail.fees && detail.fees.length > 0 ? (
                  <div style={{ marginBottom: 12 }}>
                    {detail.fees.slice(0, 10).map(function(f) {
                      var color = f.status === 'paid' ? '#16a34a' : f.status === 'exempt' ? '#64748b' : '#dc2626';
                      return (
                        <div key={f.id} style={{ fontSize: 12, padding: '4px 0', borderBottom: '1px dashed #e5e7eb' }}>
                          <span style={{ color: color, fontWeight: 600 }}>{f.status}</span>{' · '}
                          #{f.auction_id} · {fmtKrw(f.amount_total)} · {(f.delivered_at || '').slice(0, 10)}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 12 }}>이력 없음</div>
                )}

                <SectionTitle>🏆 낙찰 횟수: {detail.wonCount || 0}건</SectionTitle>

                <SectionTitle>📈 최근 입찰 ({detail.recentBids ? detail.recentBids.length : 0}건)</SectionTitle>
                {detail.recentBids && detail.recentBids.length > 0 ? (
                  <div>
                    {detail.recentBids.map(function(bid, i) {
                      return (
                        <div key={i} style={{ fontSize: 12, padding: '4px 0', borderBottom: '1px dashed #e5e7eb' }}>
                          #{bid.auction_id} {bid.auction_title || ''} · {fmtKrw(bid.bid_amount)}{' · '}
                          <span style={{ color: '#94a3b8' }}>{(bid.created_at || '').slice(0, 16)}</span>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div style={{ fontSize: 12, color: '#94a3b8' }}>입찰 이력 없음</div>
                )}

                <div style={{ marginTop: 16, padding: 12, background: '#fef3c7', borderRadius: 6, fontSize: 12, color: '#78350f' }}>
                  💡 정지 · 재활성화 · 기기 초기화 등 액션은{' '}
                  <a href="https://auction.autodex.kr/admin" target="_blank" rel="noopener noreferrer" style={{ color: '#78350f', fontWeight: 700 }}>
                    auction admin
                  </a>
                  {' '}사이트에서 처리합니다.
                </div>
              </div>
            ) : (
              <div style={{ fontSize: 13, color: '#94a3b8' }}>바이어 정보를 불러올 수 없습니다</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

function SectionTitle({ children }) {
  return <div style={{ fontSize: 12, fontWeight: 700, color: '#475569', marginTop: 16, marginBottom: 6, borderBottom: '1px solid #e5e7eb', paddingBottom: 4 }}>{children}</div>;
}

function KV({ k, v }) {
  return (
    <div style={{ display: 'flex', fontSize: 12, padding: '2px 0' }}>
      <div style={{ minWidth: 90, color: '#64748b' }}>{k}</div>
      <div style={{ flex: 1, color: '#1B3A5C' }}>{v == null || v === '' ? '-' : v}</div>
    </div>
  );
}

function Pill({ children, color }) {
  return (
    <span style={{ display: 'inline-block', padding: '4px 10px', background: color || '#e0e7ff', color: color ? '#fff' : '#3730a3', borderRadius: 12, fontSize: 12, fontWeight: 600 }}>
      {children}
    </span>
  );
}

export default AdminAuctionBuyers;
